import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges ,ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { Constant } from 'src/app/Core/services/data';
import { ImageProxyService } from 'src/app/Core/services/image-proxy-service';
import { PlaylistService } from 'src/app/Core/services/playlist.service';
import { Series, SeriesService } from 'src/app/Core/services/series.service';
import { UtilService } from 'src/app/Core/services/util.service';

@Component({
  selector: 'app-series-grid',
  templateUrl: './series-grid.component.html',
  styleUrls: ['./series-grid.component.css']
})
export class SeriesGridComponent implements OnInit {
  @Input() selectedcategory: any;
  @Input() isLoading: any;
  categoryId: any;
  isFavourit:boolean = false;
  favSeries: any;

  sortType: any;
  subscription: Subscription;
  isSort: boolean = true;
  seriesList: any;
  defaultList: any;
  JSONDatas: any = [];
  filterTerm: string;
  filteredList:any =[]
  id:any
  @ViewChild('popover') popover: any;
  sortButton: any = [{ label: 'Default', val: 'default', selected: true },
  { label: 'A - Z', val: 'atoz', selected: false },
  { label: 'Z - A', val: 'ztoa', selected: false },
  ];
  translation=['COMMON.DEFAULT','COMMON.A-Z','COMMON.Z-A']
  stream_Url: any;
  isLocal:boolean= true;
  profile_id:any;

  page = 1;
  limit = 50;
  series:any;
  isLoadingMore = false;

  constructor(private seriesService:SeriesService,private imageProxyService:ImageProxyService,private playlistService:PlaylistService,private translate:TranslateService,private utilService: UtilService, private cdRef: ChangeDetectorRef, private route: Router,private router:ActivatedRoute) {
    this.subscription = this.utilService.getSorting().subscribe((res: any) => {
      this.sortType = res;
      if (this.sortType.type == 'Series') {
        this.sortSeries('name', this.sortType.sub_category);
      }
    });
  }

  ngOnInit(): void {
    this.id = this.router.snapshot.params['id'];
    const profileData = JSON.parse(localStorage.getItem('Profile') || '{}');
    const mtoken = localStorage.getItem('mtoken') || '{}';
    this.profile_id = profileData.profile_id;
    console.log(mtoken)
    if(mtoken === '{}'){
      this.isLocal = true;
    }else{
      this.isLocal = false;
      this.checkFav(this.profile_id)
    }
    // this.getSeriesInfo(this.id);
    // if (this.id) {
    //   let isExist: any;
    //   this.favSeries = JSON.parse(localStorage.getItem(Constant.SERIES_FAV)) || [];
    //   if (this.favSeries.length > 0) {
    //     isExist = _.findIndex(this.favSeries, { id: Number(this.id) });
    //     if (isExist >= 0) {
    //       this.isFavourit = true;
    //     }
    //   }
    // }
  }




   checkFav(id:any){
      this.playlistService.getAllFavData(id).subscribe((res:any)=>{
        console.log(res);
        const fabData = res;
        // const favMovieData = fabData.filter(item => item.content_id == '' );
        // console.log(favMovieData,'fav movies data');
        let index;
        fabData.map((ele: any) => {
          console.log(ele,'elements ==>',this.seriesList);
          
          index = _.findIndex(this.seriesList, { series_id : Number(ele.content_id)});
          console.log(index,'index.',ele.content_id);
          
          if (index >= 0) {
            this.seriesList[index].isFavourit = true;
          }
        });
       
      })
    }

  async ngOnChanges(changes: SimpleChanges){
    //  this.series = await this.seriesService.getSeriesByCategory(this.selectedcategory,this.page,this.limit);
    //   console.log(this.series);
    //  this.seriesList = this.series;
    //   this.filteredList = this.seriesList;
    //   this.defaultList = this.series;
     if (changes['selectedcategory']) {
    this.page = 1;

    if (this.selectedcategory === 'all') {
      this.seriesList = await this.seriesService.getAllSeries(this.page, this.limit);
    } else {
      this.seriesList = await this.seriesService.getSeriesByCategory(this.selectedcategory, this.page, this.limit);
    }

    this.filteredList = this.seriesList;
  }
  }

  async onCategorySelect(categoryId:string){
    this.selectedcategory = categoryId;
    this.page = 1;
    if(categoryId == 'all'){
      this.series = await this.seriesService.getAllSeries(this.page,this.limit);
      this.seriesList = this.series;
      this.defaultList=this.seriesList;
      this.filteredList= this.seriesList;
    }
    else{
     
    }
  }

  onScroll(event: any): void {
  const native = event.target;
  const atBottom = native.scrollTop + native.clientHeight >= native.scrollHeight - 100;

  if (atBottom && !this.isLoadingMore) {
    this.loadMoreSeries();
  }
}

async loadMoreSeries(){
   this.isLoadingMore = true;
    this.page++;
  
    let more: Series[];
  
    if (this.selectedcategory === 'all') {
      more = await this.seriesService.getAllSeries(this.page, this.limit);
    } else {
      more = await this.seriesService.getSeriesByCategory(this.selectedcategory, this.page, this.limit);
    }
  
    if (more && more.length > 0) {
      this.seriesList = this.seriesList.concat(more);
      this.filteredList = this.seriesList;
    }
  
    this.isLoadingMore = false;
}

  ngOnChangess(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (this.selectedcategory) {
      this.seriesList = this.selectedcategory;
      this.filteredList=this.seriesList;
      this.defaultList = this.selectedcategory;
      this.categoryId = this.selectedcategory[0].category_id;
      if(this.isLocal == false){
        this.checkFav(this.profile_id)
      }else{
      let index, savedArray;
      savedArray = JSON.parse(localStorage.getItem(Constant.SERIES_FAV)) || [];
      savedArray.map((ele: any) => {
        // index = _.findIndex(this.seriesList, { series_id: ele.id });
        const seriesId = typeof ele.id === 'number' ? ele.id : String(ele.id);
        // index = _.findIndex(this.seriesList, { series_id: seriesId });
        index = _.findIndex(this.seriesList, (series: any) => String(series.series_id) === String(seriesId));
        if (index >= 0) {
          this.seriesList[index].isFavourit = true;
        }
      });
    }
          // Apply search if filterTerm has a value
    if (this.filterTerm && this.filterTerm.trim()) {
      this.searchSeries();
    } else {
      this.filteredList = this.seriesList;
    }
      
    }
  }

  

  sortSeries(property, subtype: any) {
    // this.isSort = !this.isSort;
    // this.utilService.commonSort(this.isSort, 'name', this.seriesList);
    let ascDesc;
    if (subtype == 'default') {
      this.seriesList = this.defaultList;
      this.filteredList=this.seriesList;
    } else {
      (subtype == 'atoz') ? ascDesc = 'asc' : ascDesc = 'desc';
    }
    this.sortButton.map((ele: any) => {
      (subtype == ele.val) ? ele.selected = true : ele.selected = false;
    });
    if (ascDesc) {
      this.utilService.sortCommonCategorywise(property, ascDesc, this.seriesList, (callback) => {
      this.seriesList = callback;
      this.filteredList=this.seriesList;

      });
    }
  }
  resetSort() {
    this.sortButton.map((ele: any) => {
      ele.selected = false;
      return ele;
    });
    this.sortButton[0].selected = true;
  }
  translateFilter(index:any):string{
    return this.translation[index]
  }

  addtoFavourite(item: any) {
    if(this.isLocal == true){
    let savedArray = [];
    let isExist: any;
    const msg =this.translate.instant('COMMON.ADDED_SUCCESS_MSG')
    savedArray = JSON.parse(localStorage.getItem(Constant.SERIES_FAV)) || [];
    const seriesId = typeof item.series_id === 'number' ? String(item.series_id) : String(item.series_id);
    console.log(seriesId,'seriesId=>');
    
    if (savedArray.length > 0) {
      isExist = _.findIndex(savedArray, { id: seriesId });
      if (isExist == -1) {
        item.isList = true;
        savedArray.push({ id: seriesId, img: item.cover, name: item.name, fullUrl: localStorage.getItem(Constant.FULLURL_KEY) });
        localStorage.setItem(Constant.SERIES_FAV, JSON.stringify(savedArray));
        this.utilService.showErrorSuccess(`${msg}`);
        // let index = _.findIndex(this.seriesList, { series_id: seriesId});
        let index = _.findIndex(this.seriesList, (series: any) => String(series.series_id) === String(seriesId));

        if (index >= 0) {
          this.seriesList[index].isFavourit = true;
        }
      }
      if (isExist >= 0) {
        this.utilService.showErrorInfo('Item alreadey added to favourite')
      }

    }
    else { //first
      item.isList = true;
      savedArray.push({ id: seriesId, img: item.cover, name: item.name, fullUrl: localStorage.getItem(Constant.FULLURL_KEY) });
      localStorage.setItem(Constant.SERIES_FAV, JSON.stringify(savedArray));
      // let index = _.findIndex(this.seriesList, { series_id: seriesId });
      let index = _.findIndex(this.seriesList, (series: any) => String(series.series_id) === String(seriesId));

      if (index >= 0) {
        this.seriesList[index].isFavourit = true;
      }
      this.utilService.showErrorSuccess(`${msg}`);
    }
  }else{
    const body = {
      profile_id:this.profile_id,
      content_type: "series",
      content_id: item.series_id,
      content_url: item.cover
    }
    

    
    this.playlistService.addFavorites(body).subscribe((res:any) =>{
      console.log(res);
      this.isFavourit = true;
    })
  }

  }

  deleteFavourite(item: any) {
    console.log(item);
    
    item.id = item.series_id;
    const msg = this.translate.instant('COMMON.REMOVE_SUCCESS_MSG')
    this.utilService.deleteFavourit(Constant.SERIES_FAV, item, (result: any) => {
      if (result) {
        this.utilService.showErrorSuccess(`${msg}`);
       if(this.isLocal == true){

        let index = _.findIndex(this.seriesList, { series_id: item.id });
        if (index >= 0) {
          this.seriesList[index].isFavourit = false;
        }}
        else{

        }
      }
    });
  }
  gotoDetail(id) {

    let passModal: any = {
      type: 'Series',
      sub_category: 'default'
    };
    this.utilService.addSorting(passModal);
    this.route.navigate(['/series/info/' + id], { queryParams: { seriesBy: 'series', categoryId: this.categoryId } });
  }
  goToSeasonList(id: any) {
    let passModal: any = {
      type: 'Series',
      sub_category: 'default'
    };
    this.utilService.addSorting(passModal);
    this.route.navigate(['/series/list/' + id], { queryParams: { seriesBy: 'series-grid', categoryId: this.categoryId } });
  }

  getProxiedImageUrl(url: string): string {
    return this.imageProxyService.getProxiedImageUrl(url);
  }

  searchSeries(){
    this.filteredList= this.seriesList.filter((item:any)=>item.name.toLowerCase().includes(this.filterTerm.toLowerCase()))  

    // this.filteredList = this.seriesList.filter((item:any)=>item.name.toLowerCase().include(this.filterTerm.toLowerCase()))
    console.log(this.filteredList,'series list');  
  }

  clearSearch(){
    this.filterTerm = ''
    this.filteredList=this.seriesList
  }

  preventSpace(event){
    this.utilService.preventSpace(event)
  }
}